import { useAuth } from '@cibo/profile'
import { useProgramContent, useWorkflow } from '@cibo/programs'
import { ResponsiveDialog, ResponsiveDialogProps } from '@cibo/ui'
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link as MuiLink,
  Stack,
  Typography,
} from '@mui/material'
import { ROUTE } from 'navigation/types'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, generatePath, useSearchParams } from 'react-router-dom'

interface InvitedDialogProps extends Partial<ResponsiveDialogProps> {
  relationshipManager?: string
  name?: string
}

export const InvitedDialog = ({ relationshipManager, name, ...props }: InvitedDialogProps) => {
  const { t } = useTranslation('impact/InvitedDialog')
  const { username } = useAuth()
  const [isOpen, setIsOpen] = useState(false)
  const [params, setParams] = useSearchParams()
  const workflowId = params?.get('workflowId')
  const workflowQuery = useWorkflow(workflowId || undefined)
  const programQuery = useProgramContent(workflowQuery.data?.programId)

  useEffect(() => {
    if (workflowQuery.data) {
      setIsOpen(true)
    }
  }, [workflowQuery.data])

  const handleClose = () => {
    params.delete('workflowId')
    setParams(params)
    setIsOpen(false)
  }

  useEffect(() => {
    if (!workflowId) {
      setIsOpen(false)
    }
  }, [isOpen, workflowId])

  return (
    <ResponsiveDialog {...props} open={isOpen} onClose={handleClose}>
      <DialogTitle>{t('title', { name: username })}</DialogTitle>

      <DialogContent>
        <Stack spacing={2}>
          <Typography>
            {t('body', {
              relationshipManager: workflowQuery.data?.createdBy,
              programName: programQuery.data?.content?.fields?.title,
            })}
          </Typography>

          <MuiLink component={Link} underline="hover" color="secondary" to={`/`}>
            {t('learnLink')}
          </MuiLink>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>{t('cancel')}</Button>
        <Button
          component={Link}
          to={generatePath([ROUTE.PROGRAMS, ROUTE.WORKFLOW].join('/'), {
            workflowId: `${workflowId}`,
          })}
        >
          {t('reviewEnrollment')}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
